<template>
  <v-container>
    <v-layout>
      <v-flex>
        <v-toolbar color="white" dark flat dense cad>
          <v-toolbar-title class="indigo--text">Traspaso CO-CA</v-toolbar-title>
        </v-toolbar>
      </v-flex>
    </v-layout>
    <v-layout>
      <v-flex>
        <grid-traspaso
          :key="traspasoGrid"
          :contratoId="contratoId"
        ></grid-traspaso>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Vue from "vue";
import GridTraspaso from "./GridTraspaso.vue";
import axios from "axios";

export default {
  name: "visita-sub-tab",

  components: {
    GridTraspaso,
  },
  props: {
    proveedor: {},
    show: Boolean,
    tipeView: "",
  },
  data() {
    return {
      contratoId: "",
      allowSpaces: false,
      valid: false,
      fechaInicioValue: null,
      fechaFinValue: null,
      fechaInicioSelect: [],
      fechaFinSelect: [],
      visitasCont: [],
      filter: false,
      traspasoGrid: 0,
      alerta: false,
    };
  },

  computed: {},

  created() {
    this.contratoId = this.$store.getters.contratoStored;
    if (
      this.contratoId == null ||
      this.contratoId == "" ||
      this.contratoId == undefined
    ) {
      this.contratoId = this.$route.params.contratoId;
      this.loadDataComuna();
    } else {
      this.loadDataVisitas();
    }
  },
  methods: {
    async loadVisitasFilter() {
      let that = this;
      let idContrato = this.$store.getters.contratoStored;
      this.body = {
        idContrato: idContrato,

        from:
          this.fechaInicioValue && this.fechaInicioValue != null
            ? this.fechaInicioValue
            : null,
        to:
          this.fechaFinValue && this.fechaFinValue != null
            ? this.fechaFinValue
            : null,
      };
      return await axios
        .post("/visita/search_date", this.body)
        .then(function (response) {
          return response.data;
        })
        .catch((error) => {
          if (error) {
            console.log(error.response.data);
            window.getApp.$emit("ERROR_EXCEPTION", error.response.data.message);
          }
          return [];
        });
    },
    submit() {
      this.$v.$touch();
    },
    clear() {
      this.fechaInicioValue = "";
      this.fechaFinValue = "";
      this.loadDataVisitas();
    },
    async filterVisit() {
      this.filter = true;
      this.visitas = await this.loadVisitasFilter();
      this.visitasCont = this.visitas;
    },

    loadData() {},
    async loadDataVisitas() {
      //CARGA DE USUARIOS SEPARADOS POR TIPO
      this.visitas = await this.loadVisitsAll();
      this.visitasCont = this.visitas;
      if (this.visitas.length > 0) {
        this.loadFechaSelect();
        this.alerta = false;
      } else {
        this.alerta = true;
      }
    },
    async loadVisitsAll() {
      let that = this;
      return await axios
        .get("/visitas/" + that.contratoId)
        .then(function (response) {
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
          return [];
        });
    },
    loadFechaSelect() {
      let visi = [];
      this.visitas.forEach(function (v) {
        let index = visi.findIndex((x) => x.fechaVisita == v.fechaVisita);
        if (index === -1) {
          if (v.fechaVisita != null && v.fechaVisita != "") {
            visi.push(v.fechaVisita);
          }
        }
      });
      console.log(visi);
      this.fechaInicioSelect = visi;
      this.fechaFinSelect = visi;
    },
    reloadVisitas() {
      this.traspasoGrid += 1;
    },
  },
};
</script>
